import { tokens } from "@fluentui/react-components";
import { useAtomValue } from "jotai";
import { TreeMapCard } from "pages/Dashboard/components/TreeMap/TreeMapCard";
import { useTranslation } from "react-i18next";
import { selectedBenefitCurrencyAtom } from "store/index";
import { useTheme } from "styled-components";

import { Grid } from "components/styled";
import { helpAnchor } from "help/anchor";

import { useCalculatedBenefitCosts } from "../hooks/useCalculatedBenefitCosts";

export function EmployeeAndDependentTreeMap() {
  const { t } = useTranslation();
  const theme = useTheme();
  const selectedCurrency = useAtomValue(selectedBenefitCurrencyAtom);

  const { employeeCost, dependentCost } = useCalculatedBenefitCosts();

  return (
    <Grid
      style={{
        gap: "10px",
      }}
    >
      <>
        <TreeMapCard
          name={`${t("hbh.employee.label")} (${selectedCurrency})`}
          data={employeeCost}
          fill={tokens.colorPaletteDarkOrangeBackground2}
          helpAnchorName={helpAnchor("dashboard-employee-chart")}
        />
        <TreeMapCard
          name={`${t("hbh.dependent.label")} (${selectedCurrency})`}
          data={dependentCost}
          fill={theme.palette.tealLight}
          helpAnchorName={helpAnchor("dashboard-dependent-chart")}
        />
      </>
    </Grid>
  );
}
